(function () {
  'use strict';

  /* ---------------------------------------------------------
   * 1. Scroll-reveal animation for section blocks
   * --------------------------------------------------------- */
  function initScrollReveal() {
    var sections = document.querySelectorAll('main .shopify-section');
    if (!sections.length) return;

    // Skip the very first section (hero) so above-the-fold content
    // is visible immediately without waiting on a scroll trigger.
    sections.forEach(function (section, index) {
      if (index === 0) return;
      section.classList.add('reveal-on-scroll');
    });

    if (!('IntersectionObserver' in window)) {
      // Fallback: reveal everything immediately.
      sections.forEach(function (s) { s.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (section) {
      if (section.classList.contains('reveal-on-scroll')) {
        observer.observe(section);
      }
    });
  }

  /* ---------------------------------------------------------
   * 2. Sticky mobile "Add to cart" bar on product pages
   * --------------------------------------------------------- */
  function initStickyAddToCart() {
    var main = document.querySelector('main[data-template]');
    if (!main || main.dataset.template !== 'product') return;

    var buyForm = document.querySelector('main form[action*="/cart/add"]');
    var originalButton = buyForm
      ? buyForm.querySelector('button[type="submit"], button[name="add"]')
      : null;
    if (!buyForm || !originalButton) return;

    var titleEl = document.querySelector('main .product__title, main h1');
    var priceEl = document.querySelector('main .price:not(.price--sold-out) .price-item--regular, main .price__container .price-item--regular, main sale-price');
    var title = titleEl ? titleEl.textContent.trim() : document.title;
    var price = priceEl ? priceEl.textContent.trim() : '';

    var bar = document.createElement('div');
    bar.className = 'sticky-atc-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML =
      '<div class="sticky-atc-bar__info">' +
        '<p class="sticky-atc-bar__title"></p>' +
        '<p class="sticky-atc-bar__price"></p>' +
      '</div>' +
      '<button type="button" class="sticky-atc-bar__button">Add to cart</button>';
    bar.querySelector('.sticky-atc-bar__title').textContent = title;
    bar.querySelector('.sticky-atc-bar__price').textContent = price;

    document.body.appendChild(bar);

    bar.querySelector('.sticky-atc-bar__button').addEventListener('click', function () {
      if (originalButton.disabled) return;
      originalButton.click();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      observer.observe(originalButton);
    }
  }

  /* ---------------------------------------------------------
   * 3. Welcome / discount popup
   * --------------------------------------------------------- */
  function initWelcomePopup() {
    var overlay = document.getElementById('wsp-overlay');
    if (!overlay) return;

    var STORAGE_KEY = 'sashWelcomePopupDismissedUntil';
    var SNOOZE_DAYS = 3;

    function isSnoozed() {
      try {
        var until = window.localStorage.getItem(STORAGE_KEY);
        return until && Number(until) > Date.now();
      } catch (e) {
        return false;
      }
    }

    function snooze() {
      try {
        var until = Date.now() + SNOOZE_DAYS * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(STORAGE_KEY, String(until));
      } catch (e) {
        /* localStorage unavailable — fail silently, popup may reappear */
      }
    }

    function openPopup() {
      if (overlay.classList.contains('is-open')) return;
      overlay.hidden = false;
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
      });
      document.removeEventListener('mouseout', exitIntentHandler);
      window.removeEventListener('scroll', scrollHandler);
      clearTimeout(delayTimer);
    }

    function closePopup() {
      overlay.classList.remove('is-open');
      snooze();
      setTimeout(function () { overlay.hidden = true; }, 300);
    }

    if (isSnoozed()) return;

    overlay.querySelectorAll('[data-wsp-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    // Copy discount code to clipboard
    var copyBtn = overlay.querySelector('[data-wsp-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-wsp-copy');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            var original = copyBtn.textContent;
            copyBtn.textContent = 'Copied!';
            setTimeout(function () { copyBtn.textContent = original; }, 1800);
          });
        }
      });
    }

    // Trigger: whichever comes first — a short delay, 25% scroll depth,
    // or (desktop only) the cursor exiting toward the browser chrome.
    var delayTimer = setTimeout(openPopup, 7000);

    function scrollHandler() {
      var scrolled = window.scrollY;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && scrolled / max > 0.25) {
        openPopup();
      }
    }
    window.addEventListener('scroll', scrollHandler, { passive: true });

    function exitIntentHandler(e) {
      if (!e.relatedTarget && e.clientY < 10) {
        openPopup();
      }
    }
    document.addEventListener('mouseout', exitIntentHandler);
  }

  /* ---------------------------------------------------------
   * 4. Colored swatch dots for renamed premium color options
   *    (pilot products: Abdominal Wheel, Mommy Bag)
   * --------------------------------------------------------- */
  function initColorSwatches() {
    var COLOR_MAP = {
      'Matte Graphite': '#6E6E6E',
      'Midnight Sapphire': '#22456B',
      'Matte Obsidian': '#161616',
      'Sunset Amber': '#C1621B',
      'Blush Rose': '#D9A1AA',
      'Burgundy Velvet': '#5C1A2B',
      'Powder Sky': '#A9C4DC',
      'Amethyst Mist': '#6B4C7A',
      'Rose Quartz': '#C9AFAE',
      'Emerald Noir': '#1B3B2F'
    };

    var inputs = document.querySelectorAll('input[data-option-name="Color"]');
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      var label = input.labels && input.labels[0];
      if (!label || label.dataset.swatchApplied) return;

      var rawText = label.textContent.trim();
      var hex = COLOR_MAP[rawText];

      if (!hex) {
        // Handle trailing suffixes Dawn may append (e.g. unavailable state).
        Object.keys(COLOR_MAP).some(function (name) {
          if (rawText.indexOf(name) === 0) {
            hex = COLOR_MAP[name];
            return true;
          }
          return false;
        });
      }
      if (!hex) return;

      var dot = document.createElement('span');
      dot.className = 'swatch-dot';
      dot.style.setProperty('--swatch-color', hex);
      label.insertBefore(dot, label.firstChild);
      label.classList.add('has-swatch-dot');
      label.dataset.swatchApplied = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollReveal();
      initStickyAddToCart();
      initWelcomePopup();
      initColorSwatches();
    });
  } else {
    initScrollReveal();
    initStickyAddToCart();
    initWelcomePopup();
    initColorSwatches();
  }
})();
